// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__RTAUR","productName":"Table_productName__1HAbA"};